import { createContext } from 'react';

const ExternalAuthContext = createContext({
  idToken: null,
  accessToken: null,
  isAuthenticated: false,
  setTokens: () => {},
  clearTokens: () => {},
  redirectToExternalAuth: () => {}
});

export default ExternalAuthContext;